import { UserManager } from "./../../Services/UserManager/user-manager";
import { NavigationEnd, Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { Profile } from "../../Models/profile.interface";
import {
  trigger,
  state,
  transition,
  style,
  animate,
} from "@angular/animations";
import { AngularFireDatabase } from "@angular/fire/database";
import { Subject } from "rxjs";
import _ from "lodash";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
@Component({
  selector: "app-navigation-bar",
  templateUrl: "./navigation-bar.component.html",
  styleUrls: ["./navigation-bar.component.css"],
  animations: [
    trigger("trigger", [
      state("void", style({ opacity: 0 })),
      state("show", style({ opacity: 1 })),
      transition("void => *", [animate("300ms ease-in-out")]),
      transition("* => void", [animate("300ms ease-in-out")]),
    ]),
  ],
})
export class NavigationBarComponent implements OnInit {
  profileSubject;
  profile: Profile;
  unread;
  Me: string = "My Guides";
  sub: Boolean = false;
  leaving = new Subject<null>();
  hasOrg: boolean = false;
  url;
  config;
  constructor(
    private router: Router,
    public um: UserManager,
    private db: AngularFireDatabase,
    private ls: LanguageSwitchService
  ) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
    router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((event) => {
        this.url = event["url"];
      });
  }
  buttonTrigger = "void";

  ngOnInit() {
    this.um.getProfileSubject().subscribe((profile) => {
      this.profile = profile;
      this.hasOrg = _.has(profile, "organization");
    });
  }

  showSignUp = () => this.um.openSignUp();
  showLogin = () => this.um.openLogin();
  logout = () => this.um.logout();
}
